import { LanguageService } from './language.service';
import { LoggerFactory, Logger } from './logger.service';
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRouteSnapshot } from '@angular/router';

@Injectable()
export class TitleService {
  private readonly logger: Logger;

  constructor(
    private readonly title: Title,
    private readonly translator: LanguageService,
    loggerFactory: LoggerFactory,
  ) {
    this.logger = loggerFactory.get('TitleService');
  }

  public async triggerbeeGenerateTitle(snapshot: ActivatedRouteSnapshot) {
    const titles = await this.getAllTitles(snapshot);
    if (titles && titles.length !== 0) {
      this.title.setTitle(titles.join(' - ') + ' | Triggerbee');
    }
  }

  public async getHighestTitle(snapshot: ActivatedRouteSnapshot): Promise<string> {
    if (!snapshot) {
      this.logger.error('Snapshot is undefined');
    }
    if (!snapshot.data) {
      this.logger.error('Snapshot has no data');
    }
    const titles = await this.getAllTitles(snapshot);
    if (!titles || titles.length === 0) {
      this.logger.error(
        `No titles exist for "${snapshot.url}". Set its title via routing (data : { title : 'title'}).`,
      );
    }
    return titles[titles.length - 1];
  }

  public async getDeepestTitle(snapshot: ActivatedRouteSnapshot): Promise<string> {
    if (!snapshot) {
      this.logger.error('Snapshot is undefined');
    }
    if (!snapshot.data) {
      this.logger.error('Snapshot has no data');
    }
    const titles = await this.getAllTitles(snapshot);
    if (!titles || titles.length === 0) {
      this.logger.error(
        `No titles exist for "${snapshot.url}". Set its title via routing (data : { title : 'title'}).`,
      );
    }
    return titles[0];
  }

  public async getAllTitles(snapshot: ActivatedRouteSnapshot): Promise<string[]> {
    let titleParts = <string[]>[];
    if (snapshot) {
      if (snapshot.firstChild) {
        titleParts = titleParts.concat(await this.getAllTitles(snapshot.firstChild));
      }
      if (snapshot.data['title']) {
        const translationKey = snapshot.data['title'];
        const translatedValue = await this.translator.translateAsync(translationKey);
        if (
          translatedValue /* sometimes duplicates come here, filter it*/ &&
          titleParts[titleParts.length - 1] !== translatedValue
        ) {
          titleParts.push(translatedValue);
        }
      }
    }
    return titleParts;
  }
}
